import React, { useState, useCallback } from "react";

import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";
import api from "../../services/api";
import { useProgress } from "../../hooks/progress";
import Toast from "../Toast/Toast";
import errorIcon from "../Toast/Image/error.svg";
import check from "../Toast/Image/check.svg";

export default function ModalOps({
  isOpen,
  onRequestClose,
  recipient = "Usuario A",
  estado,
  tipo,
}) {
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const { setLoad } = useProgress();

  const [list, setList] = useState([]);

  const showToast = useCallback(
    (type) => {
      let toastProperties = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "error":
          toastProperties = {
            id,
            title: "",
            description: "Erro ao enviar dados",
            backgroundColor: "#D72828",
            icon: errorIcon,
          };
          break;
        case "success":
          toastProperties = {
            id,
            title: "",
            description: "Email enviado com sucesso",
            backgroundColor: "#6C5AF4",
            icon: check,
          };
          break;

        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );

  const postData = async () => {
    setLoad(true);
    await api
      .post(`csp/lead/criar/naocoberto`, {
        nome,
        email,
        estado,
        tipo,
      })
      .then((res) => {
        if (res.status === 201) {
          setLoad(false);
          showToast("success");
          window.location.href = "https://www.axsenergia.com.br/";
        } else {
          showToast("error");
          setLoad(false);
        }
      });
    setLoad(false);
  };

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="Modal"
        style={{ outline: 0 }}
        ariaHideApp={false}
        className={{
          base: "modal-base",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close",
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
        shouldCloseOnOverlayClick={true}
      >
        <div className="modal-close" onClick={onRequestClose}></div>
        <div className="modal-imgOps"></div>
        <div className="modal-text-principal">Ops!</div>
        <div className="modal-text-ops">
          <span>Ops!</span> No momento estamos ofertando serviços apenas para
          residências e empresas em Goiás, Mato Grosso, Minas Gerais, Paraná, e
          São Paulo. Se você tem uma residência, ou empresa em outros estados
          preencha seu e-mail para nossa <b>lista de espera</b>. Em breve
          teremos novidade!
        </div>
        <input
          className="modal-input"
          type="text"
          placeholder="Nome completo"
          onChange={(e) => setNome(e.target.value)}
          autoFocus
        ></input>

        <input
          className="modal-input"
          type="text"
          placeholder="E-mail"
          onChange={(e) => setEmail(e.target.value)}
        ></input>

        <button
          className="button-modal"
          id="btnOpsNext"
          disabled={!Boolean(email) || !Boolean(nome)}
          onClick={postData}
        >
          Enviar meus dados
        </button>
      </Modal>
    </>
  );
}
